<template>
    <div>
        <div :class="'totalizer-block'">
            <div>
                <div :class="'totalizer-block__inner' + (!noIconTotalizer?' inner-gap totalizer-block-display':'')">
                    <span v-if="!noIconTotalizer">
                        <i :class="iconClass"></i>
                    </span>
                    <span class="totalizer-block__inner-text">
                        {{ text }}
                    </span>
                </div>
                <div>
                    <span class="totalizer-block__inner-number" v-if="number">
                        {{ number }}
                    </span>
                    <span class="totalizer-block__inner-number" v-else>
                        {{ "-" }}
                    </span>
                </div>
            </div>
            <div v-if="secondRowData">
                <span class="totalizer-block__inner-number" v-if="hasSecondRowData">
                    {{ secondRowData }}
                </span>
                <span class="totalizer-block__inner-number" v-else>
                    {{ "-" }}
                </span>
            </div>
            <div>
                <div class="totalizer-block__detail-button"  v-if="seeDetailOption()">
                    <go-to-button
                        :route="routeName"
                        :text="translate('messages.details')"
                        icon="el-icon-right"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoToButton from '@/modules/warehouse/views/components/GoToButton.vue';

export default {
    name: 'TotalizerBlock',
    components: { GoToButton },
    props: {
        text: {
            type: String,
            default: () => ''
        },
        number: {
            type: String,
            default: () => ''
        },
        iconClass: {
            type: String,
            default: () => ''
        },
        noIconTotalizer: {
            type: Boolean,
            default: () => false
        },
        secondRowData: {
            type: String,
            default: () => ''
        },
        routeName: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    },
    methods: {
        hasSecondRowData() {
            return this.secondRowData && this.secondRowData !== '';
        },
        seeDetailOption() {
            return this.routeName && this.routeName !== '';
        },
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        }
    }
};
</script>

<style lang="scss" scoped>
.totalizer-block-display{
    display: flex;
}
.inner-gap {
    margin: 0 0 8px 0;
}
.totalizer-block {
    min-width: 24%;
    width: auto;
    background: var(--white);
    border-radius: 3px;
    justify-content: space-between;
    min-height: 89px;
    height: 100%;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    padding: 20px 20px 8px;
    .totalizer-block__inner {
        margin-right: 3px;
        display: flex;
        justify-content: left;
        align-items: center;

        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
        .lyra-icon {
            display: flex;
            padding-right: 0.5rem;
        }
        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 28px !important;
            background-color: var(--primary) !important;
            opacity: 1;
        }
    }
    .totalizer-block__inner-number {
        flex-wrap: wrap;
        font-size: 22px;
        font-weight: 500;
    }
    span {
        padding: 3px;
        &.totalizer-block__inner-text {
            max-width: 250px;
            font-weight: 500;
        }
    }
    .totalizer-block__detail-button {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
        text-align: center;
        font-weight: 500;
        margin-top: 8px;
    }
    .totalizer-block__go-to {
        font-weight: 500 !important;
    }

    &:first-child {
        margin: 2px 0px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 0px 2px 2px;
    }
}
@media only screen and (max-width: 1334px) {
    .totalizer-block {
        min-width: 48% !important;
    }
}
</style>
